var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuExchangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 98,
    viewBox: "0 0 100 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 28.4486C90.9963 29.4886 90.0485 29.8092 89.4322 28.9742C82.1598 19.1202 71.7202 19.1571 61.8027 19.1923C48.0375 20.801 34 35 34 35L14 15C23.2397 6.47691 35.2471 -0.0978078 48.1117 0.00120616C61.8708 0.107104 81.1715 3.52406 91 28.4486Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19484 48.9993C1.41524 49.0372 -0.0373683 47.5901 0.000732818 45.8173L0.836119 6.94704C0.895079 4.20367 4.22731 2.8701 6.17501 4.8104L44.3582 42.8485C46.3059 44.7888 44.9672 48.1083 42.2134 48.1671L3.19484 48.9993Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 69.5513C9.00371 68.5113 9.9515 68.1907 10.5678 69.0258C17.8402 78.8798 28.2798 78.8429 38.1973 78.8077C51.9625 77.199 66 63 66 63L86 83C76.7603 91.5231 64.7529 98.0978 51.8883 97.9988C38.1292 97.8929 18.8285 94.4759 9 69.5513Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8052 49.0007C98.5848 48.9628 100.037 50.4099 99.9993 52.1827L99.1639 91.053C99.1049 93.7964 95.7727 95.1299 93.825 93.1896L55.6418 55.1515C53.6941 53.2112 55.0328 49.8917 57.7866 49.8329L96.8052 49.0007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuExchangerIcon);
export default __webpack_public_path__ + "static/media/menu-exchanger-icon.7096fdb950e71faad71b428ce33ad824.svg";
export { ForwardRef as ReactComponent };